import { render } from "./SectionStickyBar.vue?vue&type=template&id=22475d71&scoped=true"
import script from "./SectionStickyBar.vue?vue&type=script&lang=js"
export * from "./SectionStickyBar.vue?vue&type=script&lang=js"

import "./SectionStickyBar.vue?vue&type=style&index=0&id=22475d71&lang=scss&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.44_vue@3.5.44_webpack@5.112.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22475d71"]])

export default __exports__